import { Component, OnInit, Inject, Input } from '@angular/core';
import AccessControlGlobalChartView from "./access-control-global-chart.component.html";
import { TranslateService, _ } from '@ngx-translate/core';
import { EventGuestsService } from '../../services/event-guests.service';

@Component({
  selector: 'access-control-global-chart',
  template: AccessControlGlobalChartView,
})
export class AccessControlGlobalChartComponent implements OnInit {
  data: any;
  options: any;
  labels: string[] = [];

  constructor(@Inject(TranslateService) private translate: TranslateService,
              @Inject(EventGuestsService) private eventGuestsService: EventGuestsService) { }

  ngOnInit() {
    this.labels = [
      this.translate.instant(_('dashboard.guests_not_arrived_yet')),
      this.translate.instant(_('dashboard.guest_arrived')),
      this.translate.instant(_('dashboard.guest_rejected_but_here')),
    ];
    this.eventGuestsService.accesses$.subscribe(guests => {
      this.data = {
        labels: this.labels,
      datasets: [{
        data: [
          guests.filter(g => g.access_status === 0).length,
          guests.filter(g => g.access_status === 1).length,
          guests.filter(g => g.access_status === 2).length
        ],
          backgroundColor: ['#ed5565', '#23c6c8', '#f8ac59']
        }]
      };
    });
  }

}
